import React from 'react';

export function SkeletonBox({ className = 'h-4 w-full' }: { className?: string }) {
  return <div className={`skeleton rounded ${className}`}></div>;
}

export function OrderSkeleton() {
  return (
    <div className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden dark:bg-gray-800 dark:border-gray-700">
      <div className="px-4 pt-4 pb-3 flex justify-between">
        <SkeletonBox className="h-6 w-20 rounded-full" />
        <SkeletonBox className="h-4 w-28" />
      </div>
      <div className="px-4 pb-4">
        <div className="flex gap-3 mb-4">
          <SkeletonBox className="h-12 w-12 rounded-lg shrink-0" />
          <div className="flex-1">
            <SkeletonBox className="h-5 w-36 mb-2" />
            <SkeletonBox className="h-4 w-44" />
          </div>
          <SkeletonBox className="h-4 w-16" />
        </div>
        <div className="flex justify-between items-end">
          <div>
            <SkeletonBox className="h-6 w-24 mb-2" />
            <SkeletonBox className="h-4 w-20" />
          </div>
          <SkeletonBox className="h-9 w-28 rounded-full" />
        </div>
      </div>
    </div>
  );
}

export function CafeSkeleton() {
  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden dark:bg-gray-800">
      <SkeletonBox className="h-36 w-full" />
      <div className="p-3">
        <SkeletonBox className="h-5 w-32 mb-2" />
        <SkeletonBox className="h-4 w-full mb-1" />
        <SkeletonBox className="h-4 w-2/3" />
      </div>
    </div>
  );
}
